import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "@apollo/react-hooks";
import { navigate } from "@reach/router";
import * as Yup from "yup";
import { FormErrors } from "@squirrellearningltd/go-teacher-components";
import { CREATE_FRANCHISE } from "../services/graphql";
import styles from "../Franchises.module.scss";

const AddFranchise = () => {
  const [formErrors, setFormErrors] = useState([]);
  const [createFranchise, { loading }] = useMutation(CREATE_FRANCHISE);
  const schema = Yup.object().shape({
    name: Yup.string().trim().required("Please enter a territory name"),
    code: Yup.string().trim().required("Please enter a code"),
    countryCode: Yup.string().trim(),
    currency: Yup.string().trim(),
    leadUserName: Yup.string().trim(),
    leadUserEmail: Yup.string().trim().email("Please enter a valid email address")
  });
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    mode: "onSubmit"
  });

  const onSubmit = values => {
    if (loading) return;
    setFormErrors([]);
    createFranchise({
      variables: {
        name: values.name,
        code: values.code,
        countryCode: values.countryCode || undefined,
        currency: values.currency || undefined,
        leadUserName: values.leadUserName || undefined,
        leadUserEmail: values.leadUserEmail || undefined
      }
    }).then(({ data }) => {
      const result = data && data.createFranchise;
      if (result && result.errors && result.errors.length > 0) {
        setFormErrors(result.errors);
        return;
      }
      if (result && result.franchise && result.franchise.id) {
        navigate("/franchises");
        return;
      }
      setFormErrors(["Unable to add the territory. Please try again."]);
    }).catch(error => {
      setFormErrors([error.message]);
    });
  };

  return (
    <div className={styles.franchises}>
      <h1 className="title">Add a new territory</h1>
      <form className={styles.territoryForm} onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className={styles.detailPanel}>
          <div className={`basic-form__group-full ${styles.formGroup}`}>
            <label htmlFor="name" className="basic-form__text-label">Name</label>
            <input id="name" name="name" type="text" className="basic-form__text-box" ref={register} aria-required="true" disabled={loading} />
            {errors.name && <p className="basic-form__hint u-m-top-0">{errors.name.message}</p>}
          </div>
          <div className={`basic-form__group-full ${styles.formGroup}`}>
            <label htmlFor="code" className="basic-form__text-label">Code</label>
            <input id="code" name="code" type="text" className="basic-form__text-box" ref={register} aria-required="true" disabled={loading} />
            {errors.code && <p className="basic-form__hint u-m-top-0">{errors.code.message}</p>}
          </div>
          <div className={`basic-form__group-full ${styles.formGroup}`}>
            <label htmlFor="countryCode" className="basic-form__text-label">Country code</label>
            <input id="countryCode" name="countryCode" type="text" className="basic-form__text-box" ref={register} disabled={loading} />
          </div>
          <div className={`basic-form__group-full ${styles.formGroup}`}>
            <label htmlFor="currency" className="basic-form__text-label">Currency</label>
            <input id="currency" name="currency" type="text" className="basic-form__text-box" ref={register} disabled={loading} />
          </div>
          <div className={`basic-form__group-full ${styles.formGroup}`}>
            <label htmlFor="leadUserName" className="basic-form__text-label">Lead user name</label>
            <input id="leadUserName" name="leadUserName" type="text" className="basic-form__text-box" ref={register} disabled={loading} />
          </div>
          <div className={`basic-form__group-full ${styles.formGroup}`}>
            <label htmlFor="leadUserEmail" className="basic-form__text-label">Lead user email</label>
            <input id="leadUserEmail" name="leadUserEmail" type="email" className="basic-form__text-box" ref={register} disabled={loading} />
            {errors.leadUserEmail && <p className="basic-form__hint u-m-top-0">{errors.leadUserEmail.message}</p>}
          </div>
          {formErrors.length > 0 && <FormErrors errors={formErrors} />}
        </div>
        <div className={styles.formActions}>
          <button type="button" className={styles.button} disabled={loading} onClick={() => navigate("/franchises")}>Cancel</button>
          <button type="submit" className={styles.primaryButton} disabled={loading}>{loading ? "Adding..." : "Add"}</button>
        </div>
      </form>
    </div>
  );
};

export default AddFranchise;
